import React, { useEffect } from 'react'
import s from './ErrorPage.module.scss'
import TagManager from "react-gtm-module"

const ErrorPage = ({children}) => {
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'pageview',
        pagePath: '/error',
        pageTitle: 'ErrorPage',
      },
    });
  }, [])
  return (
    <div className={s.Error}>
      <h2>Ruh-ro!</h2>
      <p>Looks like there’s an issue accessing the motion sensors or camera on your device. Both are needed to enjoy this experience.</p>
      <div className={s.container}>
      <div className={s.buttons}>
      <a href="/experience">Retry</a>
      <a href="/">Exit</a>
      </div>
      </div>
    </div>
  )

}

export default ErrorPage